/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountStateEnum = 'ONBOARDED' | 'READY' | 'ASSIGNED' | 'FIXING' | 'TOMBSTONED' | 'ABANDONED';

export const AccountStateEnum = {

    ONBOARDED: 'ONBOARDED' as AccountStateEnum,

    READY: 'READY' as AccountStateEnum,

    ASSIGNED: 'ASSIGNED' as AccountStateEnum,

    FIXING: 'FIXING' as AccountStateEnum,

    TOMBSTONED: 'TOMBSTONED' as AccountStateEnum,

    ABANDONED: 'ABANDONED' as AccountStateEnum
};

